export class PreviousAppointment {
    appointmentId: number;
    providerName: string;
    patientId: number;
    appointmentDate: Date;
    appointmentTime: object;
    appointmentDateTime: string;
    encounterType: string;
    encryptedAppointmentId: string;
}